module.exports = __webpack_public_path__ + "PTMETTAservice-2.82f918f3.png";